import React from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const getTrendColorClass = (trend) => {
  if (!trend) return 'text-slate-600';
  
  // Handle object format { value: '+12%', positive: true }
  if (typeof trend === 'object') {
    return trend.positive ? 'text-emerald-600' : 'text-red-600';
  }
  
  // Handle string format
  if (trend.startsWith('+') || trend.startsWith('↑')) return 'text-emerald-600';
  if (trend.startsWith('-') || trend.startsWith('↓')) return 'text-red-600';
  return 'text-slate-600';
};

export const StatsCard = ({ title, value, trend, trendLabel, icon: Icon, iconBg, onClick }) => {
  // Extract trend value if it's an object
  const trendValue = typeof trend === 'object' ? trend.value : trend;
  const trendColorClass = getTrendColorClass(trend);

  return (
    <Card
      data-testid={`stats-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
      className={cn(
        'rounded-xl border border-slate-200 bg-white shadow-sm p-6 transition-all',
        onClick && 'cursor-pointer hover:shadow-md hover:border-slate-300'
      )}
      onClick={onClick}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-xs text-muted-foreground font-medium uppercase tracking-wider">
            {title}
          </p>
          <p className="text-3xl font-bold tracking-tight text-slate-900 mt-2">
            {value}
          </p>
          {(trendValue || trendLabel) && (
            <div className="mt-2 flex items-center gap-1.5">
              {trendValue && (
                <span className={cn('text-xs font-medium', trendColorClass)}>
                  {trendValue}
                </span>
              )}
              {trendLabel && (
                <span className="text-xs text-slate-500">{trendLabel}</span>
              )}
            </div>
          )}
        </div>
        {Icon && (
          <div
            className={cn(
              'flex h-12 w-12 items-center justify-center rounded-full',
              iconBg || 'bg-slate-100'
            )}
          >
            <Icon className="h-6 w-6" />
          </div>
        )}
      </div>
    </Card>
  );
};
